import React, { useState, cloneElement, useEffect } from "react";
import IconButton from "@material-ui/core/IconButton";
import { Close } from "@material-ui/icons";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import Typography from "@material-ui/core/Typography";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import withStyles from "@material-ui/core/styles/withStyles";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import * as Yup from "yup";
import Button from "@material-ui/core/Button/Button";
import Slide from "@material-ui/core/Slide/Slide";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import TextField from "@material-ui/core/TextField";

const styles = (theme) => ({
  textField: {
    "&.MuiInputBase-formControl": {
      marginTop: 0,
    },
  },
  dialogContent: {
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      padding: "0px 24px",
    },
  },
  dialogActions: {
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      padding: "8px 20px 20px 20px",
    },
  },
  dialogTitle: {
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      padding: "16px 24px 0px 24px",
    },
  },
  label: {
    paddingTop: 6,
    paddingBottom: 7,
    fontSize: 20,
    lineHeight: "22px",
  },
  sectionHeading: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontWeight: 500,
    marginBottom: 10,
    lineHeight: "28px",
    fontSize: 24,
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      fontSize: 16,
      display: "inline-block",
    },
    color: theme.palette.grey[800],
  },
  paper: {
    width: "100%",
  },
  modalCloseBtn: {
    position: "absolute",
    top: 10,
    right: 10,
  },
});
const defaultValues = {
  repCodeId: undefined,
  bdRepCode: "",
  crdNumber: "",
};

const crdSchema = Yup.object().shape({
  bdRepCode: Yup.string().required(),
  crdNumber: Yup.string().required(),
});
const AddRepCodeModal = (props) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(defaultValues);
  const [isFormValid, setIsFormValid] = useState(false);
  const { classes, dialogAnchorComponent, saveUserRepCode, userCrd, repCode } =
    props;

  useEffect(() => {
    validateForm();
  }, [data]);

  useEffect(() => {
    setData({
      crdNumber: userCrd,
    });
    if (repCode) {
      setData({
        repCodeId: repCode.id,
        bdRepCode: repCode.bdRepCode,
        crdNumber: userCrd,
      });
    }
  }, [open, repCode]);

  const saveRepCode = (e) => {
    saveUserRepCode({ ...data, isSplit: false, crdNumber: userCrd });
    handleCloseModal();
  };

  const validateForm = () => {
    setIsFormValid(crdSchema.isValidSync(data));
  };

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setData(defaultValues);
  };

  return (
    <React.Fragment>
      {cloneElement(dialogAnchorComponent, { onClick: handleOpenModal })}
      <Dialog
        open={open}
        TransitionComponent={Slide}
        TransitionProps={{ direction: "up" }}
        onClose={handleCloseModal}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        maxWidth={"sm"}
        classes={{ paper: classes.paper }}
        aria-labelledby="custodian-bd-rep-modal-title"
        aria-describedby="custodian-bd-rep-modal-description"
      >
        <Box ml={4} mr={4} mt={3}>
          <DialogTitle
            disableTypography
            id="custodian-bd-rep-modal-title"
            classes={{ root: classes.dialogTitle }}
          >
            <Typography variant={"h4"} className={classes.sectionHeading}>
              Custodian and BD Rep Code Details
            </Typography>
            <IconButton
              className={classes.modalCloseBtn}
              aria-label="Close"
              onClick={handleCloseModal}
            >
              <Close color="primary" />
            </IconButton>
          </DialogTitle>

          <DialogContent classes={{ root: classes.dialogContent }}>
            <Grid item xs={12} container>
              <Grid item xs={4}>
                <Typography className={classes.label}>BD Rep Code*</Typography>
              </Grid>
              <Grid item xs={7}>
                <TextField
                  data-cy="repCodes.add.modal.bdRepCode"
                  fullWidth
                  value={data.bdRepCode}
                  onChange={(e) =>
                    setData({
                      ...data,
                      bdRepCode: e.target.value.toUpperCase(),
                    })
                  }
                  InputProps={{
                    inputProps: {
                      "aria-label": "BD Rep Code",
                    },
                    classes: { root: classes.textField },
                  }}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} container>
              <Grid item xs={4}>
                <Typography className={classes.label}>CRD Number*</Typography>
              </Grid>
              <Grid item xs={7}>
                <TextField
                  type="number"
                  fullWidth
                  disabled
                  value={userCrd}
                  InputProps={{
                    classes: { root: classes.textField },
                    inputProps: {
                      "aria-label": "CRD Number",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>
        </Box>
        <DialogActions classes={{ root: classes.dialogActions }}>
          <Button onClick={handleCloseModal}>Cancel</Button>
          <Button
            disabled={!isFormValid}
            variant="contained"
            color="primary"
            onClick={saveRepCode}
            data-cy="repCodes.add.modal.save"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

AddRepCodeModal.propTypes = {
  userCrd: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
  saveUserRepCode: PropTypes.func.isRequired,
  repCode: PropTypes.object,
};

export default withStyles(styles)(AddRepCodeModal);



// WEBPACK FOOTER //
// ./src/containers/UserRepCodes/components/AddRepCodeModal/index.jsx